/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import CalendarLocale from '../calendar/sk_SK';
import TimePickerLocale from '../time-picker/sk_SK';

// ç»ä¸åå¹¶ä¸ºå®æ´ç Locale
const locale = {
  lang: {
    placeholder: 'VybraÅ¥ dÃ¡tum',
    rangePlaceholder: ['Od', 'Do'],
    ...CalendarLocale
  },
  timePickerLocale: {
    ...TimePickerLocale
  }
};

// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

export default locale;
